import React from "react";
import { Navigate } from "react-router-dom";

const RestrictedRoute = ({ condition, redirectUrl, children }) =>
    !condition ? <Navigate to={redirectUrl} /> : children;

export { RestrictedRoute };
